import { Directive, HostListener, Input } from '@angular/core';
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[phone]',
})
export class PhoneDirective {
    @Input() valor = '';
    @HostListener('input', ['$event']) onInput(event: Event) {
        let target = event.target as HTMLInputElement;
        target.value = target.value.toUpperCase().replace(/[a-zA-Zç;?><_=+/ºª%$#"!|()&´`«»'}{*^~\t\n]/gi, '');
    }
}
